import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=4f8cfe2c&scoped=true&"
var script = {}
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=4f8cfe2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cfe2c",
  null
  
)

export default component.exports